import Styled from 'styled-components'
import { EyeOutlined, ShoppingCartOutlined, UserOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useHookstate } from '@hookstate/core'
import { DrawerChat } from './drawer-chat.component'
import { useTranslation } from 'react-i18next'

const ControlPanel = Styled.article`
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.4rem;
  background-color: #ffffff;
`
const Title = Styled.h1`
  width: 100%;
  height: 5.8rem;
  color: #000000;
  font-size: 1.6rem;
  padding: 1.6rem 2.4rem;
  border-bottom: 1px solid #f0f0f0;
`
const Content = Styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2.4rem;
`
const Row = Styled.div`
  width: 100%;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  color: #727374;
  font-weight: bold;

  & > span{
    margin-right: 1rem;
  }
  p{
    width: 24rem;
    margin: 0;
  }
  & > button{
    width: 12.5rem;
  }
`
type ChatWidgetProps = {
  jobUuid: string
  currentUserId: string
  currentUserName: string
}

const ChatWidgetV3 = ({ jobUuid, currentUserId, currentUserName }: ChatWidgetProps) => {
  const { t } = useTranslation()
  const openModal = useHookstate<boolean>(false)
  const selectedTab = useHookstate<string>('')

  return (
    <>
      <ControlPanel>
        <Title>{t('chat-widget.title')}</Title>
        <Content>
          <Row>
            <UserOutlined />
            <p>{t('chat-widget.customer')}</p>
            <Button
              onClick={() => {
                openModal.set(true)
                selectedTab.set('customer')
              }}
            >
              {t('chat-widget.open')}
            </Button>
          </Row>
          <Row>
            <ShoppingCartOutlined />

            <p>{t('chat-widget.resource')}</p>
            <Button
              onClick={() => {
                openModal.set(true)
                selectedTab.set('resource')
              }}
            >
              {t('chat-widget.open')}
            </Button>
          </Row>
          <Row>
            <EyeOutlined />
            <p>{t('chat-widget.review')}</p>
            <Button
              onClick={() => {
                openModal.set(true)
                selectedTab.set('review')
              }}
            >
              {t('chat-widget.open')}
            </Button>
          </Row>
        </Content>
      </ControlPanel>
      {openModal.get() === true && (
        <DrawerChat
          openModal={openModal}
          jobUuid={jobUuid}
          currentUserId={currentUserId}
          currentUserName={currentUserName}
          selectedTab={selectedTab.get()}
        />
      )}
    </>
  )
}

export { ChatWidgetV3 }
